module.exports = __webpack_public_path__ + "static/Composite_Secondary_mobile-af2984b0cc10d0abceecc2eb6901e8b2.png";